import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import * as authService from '../../services/auth/auth-service';
import * as Loader from '../../common/common';
import { withRouter } from '../../common/hocs';
class VerfiyUser extends Component {
	constructor(props) {
		super(props);
		this.checkToken = this.checkToken.bind(this);
		this.sendTokenAgain = this.sendTokenAgain.bind(this);
	}
	state = {
		token:'',
		error: '',
		msg: '',
	}
	async sendTokenAgain() {
		Loader.showLoader();
		const { params } = this.props;
		let { response, err } = await authService.resetToken(params.token);
		Loader.hideLoader();
        if (err) {
        } else if (response.data && response.data.err) {
            this.setState({
                token: '',
                error: response.data.err,
                msg:''
            })
        } else {
            this.setState({
                token: '',
                msg: response.data.msg,
                error:'',
            })
        }
	}
	async checkToken() {
		var data = Object.assign({},this.state.token)
		const { params } = this.props;
		data.token = params.token
		Loader.showLoader();
		let { response, err } = await authService.verifyToken(data.token);
		Loader.hideLoader();
        if (err) {
        } else if (response.data && response.data.err) {
            this.setState({
                token: '',
                error: response.data.err,
                msg:''
            })
        } else {
            this.setState({
                token: '',
                msg: response.data.msg,
                error:'',
            })
        }
	}
	componentDidMount() {
		this.checkToken();
	}
	render() {
		var { msg, error } = this.state
		return (

			<div className="app flex-row align-items-center">
				<div className="container">
					<div style={{ textAlign: "center" }}>
						<img src="/images/logo.jpg" width="201" height="40" alt="logo" />
					</div>
					<p></p>
					<div className="row justify-content-center">
						<div className="col-md-6">
							<div className="card mx-4">
								<div className="card-body p-4">
									{msg ?
										<div style={{ textAlign: "center" }}>
											<span>{msg}</span>&nbsp;&nbsp;
											<div><Link to="/Login">Click here to Login</Link></div>
										</div>
										: null}
									{error ?
										<div style={{ textAlign: "center" }}>
											<span>{error}</span>
											<div><Link to="/Login">Go to Login</Link></div>
										</div>
										: null}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

// HOC to inject router params
export default withRouter(VerfiyUser);
